import { S } from '../strings';

// "Luettu / hiljennä" toggle, sits next to BookmarkStar. Off = open eye
// (item is shown), on = struck-through eye (item is hidden unless
// "Näytä kaikki" is on). Inline SVG so it inherits `color` like the star.
export function MuteToggle({
  active,
  onToggle,
}: {
  active: boolean;
  onToggle: () => void;
}) {
  // Toggle-button pattern: the accessible name stays fixed and aria-pressed
  // carries the state, so screen readers announce "Hiljennä…, pressed"
  // rather than a name that flips. Only the hover tooltip names the action.
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onToggle();
      }}
      aria-label={S.mute.add}
      aria-pressed={active}
      title={active ? S.mute.remove : S.mute.add}
      style={{
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        padding: 2,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        color: active ? '#0078D4' : 'var(--text-muted)',
        transition: 'color 0.15s',
      }}
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
        <circle cx="12" cy="12" r="3" />
        {active && <path d="M3 3l18 18" />}
      </svg>
    </button>
  );
}
